import IconUser from '@assets/icons/user.svg?react';
import {
	Box,
	Button,
	MenuItem,
	Popover,
	TextField,
	type Theme,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { AuthUser } from '../../../redux/identity/identityTypes';
import DatabaseSelector from '../Header/DatabaseSelector';
import LanguageFlag from '../LanguageFlag';
import UserBadge from './UserBadge';

type UserPopoverProps = {
	open: boolean;
	anchorEl: HTMLElement | null;
	onClose: () => void;
	onOpenProfile: () => void;
	user: AuthUser | null;
	languages: string[];
	currentLanguage: string;
	onLanguageChange: (value: string) => void;
	onLogout: () => void;
};

const UserPopover = ({
	open,
	anchorEl,
	onClose,
	onOpenProfile,
	user,
	languages,
	currentLanguage,
	onLanguageChange,
	onLogout,
}: UserPopoverProps) => {
	const { t } = useTranslation();
	return (
		<Popover
			open={open}
			anchorEl={anchorEl}
			onClose={onClose}
			sx={{ mt: '4px' }}
			anchorOrigin={{
				vertical: 'bottom',
				horizontal: 'right',
			}}
			transformOrigin={{
				vertical: 'top',
				horizontal: 'right',
			}}
		>
			<Box
				sx={(theme: Theme) => ({
					minWidth: 280,
					p: 2,
					display: 'flex',
					flexDirection: 'column',
					backgroundColor: theme.palette.background.paper,
				})}
			>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						mb: '20px',
						//   gap: 1,
					}}
				>
					<UserBadge isHorizontal={false} />
				</Box>
				<Button
					variant="outlined"
					fullWidth
					size="large"
					onClick={onOpenProfile}
					sx={{
						textTransform: 'none',
						fontWeight: 400,
						mb: '12px',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						gap: 1,
						color: 'primary',
					}}
				>
					{t('userPopover.profileArea')}
					<IconUser style={{ width: 16, height: 16 }} />
				</Button>
				<DatabaseSelector />
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'space-between',
						//   alignItems: 'center',
						gap: 1,
					}}
				>
					<TextField
						select
						size="small"
						value={currentLanguage}
						onChange={(event) => onLanguageChange(event.target.value)}
						sx={{ minWidth: 80 }}
					>
						{languages.map((language) => (
							<MenuItem key={language} value={language}>
								<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
									<LanguageFlag code={language} />
									{language.toUpperCase()}
								</Box>
							</MenuItem>
						))}
					</TextField>
					<Button
						variant="outlined"
						color="error"
						onClick={onLogout}
						sx={{
							whiteSpace: 'nowrap',
							textTransform: 'none',
						}}
					>
						{t('userPopover.logout')}
					</Button>
				</Box>
			</Box>
		</Popover>
	);
};

export default UserPopover;
